
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("baR74", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ee6704da46cadf68$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $ee6704da46cadf68$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': 'Din chathistorik gemmes i op til 30 dage.',
    'ai-mate.chat-error-banner.title': 'Start ny chat',
    'ai-mate.chat-error.description': "Pr\xf8v at <btn>genindl\xe6se chat</btn>.",
    'ai-mate.chat-error.rate-limited-description': "Du har n\xe5et det maksimale antal anmodninger. Pr\xf8v igen senere.",
    'ai-mate.chat-error.rate-limited-title': 'For mange anmodninger',
    'ai-mate.chat-error.rovo-inactive-description': "Det ser ud til, at Rovo ikke er aktiveret p\xe5 dit website. <link>Ops\xe6tning af Rovo</link>",
    'ai-mate.chat-error.rovo-inactive-title': 'Rovo er inaktiv',
    'ai-mate.chat-error.title': "Vi er ikke sikre p\xe5, hvad der gik galt",
    'ai-mate.main-chat.close-chat-button-label': 'Luk',
    'ai-mate.main-chat.maximize-chat-button-label': "Fuld sk\xe6rm",
    'ai-mate.main-chat.minimize-chat-button-label': 'Gendan visning',
    'ai-mate.main-chat.new-chat-button-label': 'Ny',
    'ai-mate.main-chat.new-chat-button-label-full-screen': 'Ny chat',
    'conversation-assistant-button.label': 'Chat',
    'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Send',
    'highlight-actions.rovo-chat-custom-prompt.placeholder': "Sp\xf8rg AI om dette",
    'highlight-actions.rovo-chat-explain-option.text': 'Forklar',
    'highlight-actions.rovo-chat-explain-prompt': "Forklar dette ved at omformulere det og tilf\xf8je yderligere oplysninger, men brug meget simpelt sprog og korte s\xe6tninger, og giv eksempler eller definitioner p\xe5 eventuel teknisk terminologi, der er brugt i den oprindelige formulering.",
    'highlight-actions.rovo-chat-find-resources-option.text': 'Find ressourcer',
    'highlight-actions.rovo-chat-find-resources-prompt': "Find ressourcer udelukkende inden for organisatorisk viden, der st\xf8tter de foretagne erkl\xe6ringer.",
    'highlight-actions.rovo-chat-give-examples-option.text': 'Giv eksempler',
    'highlight-actions.rovo-chat-give-examples-prompt': "Giv eksempler p\xe5 dette fra organisationsressourcer eller offentlig viden. Hvis der ikke kan ydes nogen ressourcer, kan du fors\xf8ge at give et metaforisk eksempel, der muligvis kan hj\xe6lpe nogen med at forst\xe5 dette bedre.",
    'highlight-actions.rovo-chat-give-feedback-option.text': 'Giv feedback',
    'highlight-actions.rovo-chat-give-feedback-prompt': "Giv feedback ved at gennemg\xe5 formuleringen af dette. Komment\xe9r p\xe5 ordvalg, grammatik og tegns\xe6tning. V\xe6r positiv og entusiastisk, men angiv altid mindst \xe9n ting, der kan forbedres eller \xe6ndres.",
    'highlight-actions.rovo-chat-more-options.tooltip': 'Chatanbefalinger',
    'highlight-actions.rovo-chat-open-chat.tooltip': "\xc5bn Chat",
    'highlight-actions.rovo-chat-summarize-option.text': 'Opsummer',
    'highlight-actions.rovo-chat-summarize-prompt': "Fremh\xe6v de vigtigste punkter fra dette. Fokus\xe9r p\xe5 essentielle oplysninger, og udeluk un\xf8dvendige detaljer. Giv et kortfattet overblik i et enkelt afsnit.",
    'highlight-actions.rovo-chat.button-text': 'Chat',
    'highlight-actions.rovo-chat.button-text-ask-in-chat': "Sp\xf8rg i chat",
    'horizontal-scroll-container.scroll-left': 'Rul til venstre',
    'horizontal-scroll-container.scroll-right': "Rul til h\xf8jre"
};

});


//# sourceMappingURL=da.41fdb362.js.map
